import { useCopyAPIKeyIntegration } from "../CopyAPIKeyModal/useCopyAPIKeyIntegration";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import ZapierLogo from "./ZapierLogo";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ZapierCard() {
  const {
    showCopyAPIKeyModal
  } = useCopyAPIKeyIntegration('zapier');
  return /*#__PURE__*/_jsx(IntegrationCard, {
    "data-testid": "zapier-card",
    icon: /*#__PURE__*/_jsx(ZapierLogo, {}),
    title: "Zapier",
    subTitle: "Integrate Anchor with hundreds of other apps to automate your work",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      onClick: showCopyAPIKeyModal,
      "data-testid": "zapier-card-connect",
      children: "Connect"
    })
  });
}